// Generated by Claude Code
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { FeatureGuard } from '#components/tools/feature-guard.tsx'
import { AnalyticsUnavailable } from '#components/domain/operations/analytics/analytics-unavailable.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'

export const Route = createFileRoute('/_app/$companyId/analytics')({
  component: RouteComponent,
  staticData: { title: 'Analysis', appShell: true },
})

function RouteComponent() {
  const { t } = useTranslation('analytics')

  return (
    <FeatureGuard 
      service={PermissionService.ANALYTICS} 
      title={t('title')} 
      fallback={(denial) => <AnalyticsUnavailable denial={denial} />}
    >
      <Outlet />
    </FeatureGuard>
  )
}
